import React, { useEffect, useState } from 'react';
import api from '../services/api';

export default function Projects() {
  const [projects, setProjects] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [companyFilter, setCompanyFilter] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const [p, c] = await Promise.all([
          api.get('/projects'),
          api.get('/companies'),
        ]);
        setProjects(p.data);
        setCompanies(c.data);
      } catch (e) {
        setError(e.response?.status
          ? `Failed to load projects (HTTP ${e.response.status}${e.response.data?.error ? ': ' + e.response.data.error : ''})`
          : 'Failed to load projects — is the backend running on :9091?');
      }
      finally { setLoading(false); }
    })();
  }, []);

  const companyName = (id) => companies.find(c => c.id === id)?.name || '—';
  const shown = companyFilter
    ? projects.filter(p => String(p.companyId) === String(companyFilter))
    : projects;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a' }}>Projects</h1>
          <p style={{ color: '#64748b' }}>Projects from the shared CLTS directory (read-only)</p>
        </div>
        <div style={{ width: 240 }}>
          <select value={companyFilter} onChange={e => setCompanyFilter(e.target.value)}>
            <option value="">All companies</option>
            {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
        </div>
      </div>

      {error && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{error}</div>}

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>Loading...</div>
        ) : shown.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#94a3b8' }}>{error ? 'Could not load projects.' : 'No projects found.'}</div>
        ) : (
          <table>
            <thead>
              <tr><th>Name</th><th>Company</th><th>Stack</th><th>Platform</th><th>Status</th></tr>
            </thead>
            <tbody>
              {shown.map(p => (
                <tr key={p.id}>
                  <td style={{ fontWeight: 600 }}>{p.name}</td>
                  <td>{companyName(p.companyId)}</td>
                  <td>{p.stack || '—'}</td>
                  <td>{p.platform || '—'}</td>
                  <td>{p.status || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
